import { render, staticRenderFns } from "./Christmas.vue?vue&type=template&id=55493bb2&scoped=true"
import script from "./Christmas.vue?vue&type=script&lang=js"
export * from "./Christmas.vue?vue&type=script&lang=js"
import style0 from "./Christmas.vue?vue&type=style&index=0&id=55493bb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55493bb2",
  null
  
)

export default component.exports